import React, { useContext, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

import { AppRoutes } from "../../constants/appRoutes";
import DashboardIcon from "@mui/icons-material/Dashboard";
import EditIcon from "@mui/icons-material/Edit";
import { LoadingContext } from "../../context/contextProvider";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import Services from "../../services/services";
import { ThemeColorsEnum } from "../../constants/enums";
import TruckFormPage from "./TruckFormPage";

const breadcrumbs = [
  {
    IconComponent: DashboardIcon,
    title: "Dashboard",
    to: AppRoutes.dashboard,
  },
  {
    IconComponent: LocalShippingIcon,
    title: "Trucks",
    to: AppRoutes.trucks,
  },
  {
    IconComponent: EditIcon,
    title: "Edit",
  },
];

const TruckEditPage = (props) => {
  const { id } = useParams();
  const { state } = useLocation();

  const [truck, setTruck] = useState(state?.truck);
  const { setLoading } = useContext(LoadingContext);

  useEffect(() => {
    if (id && !state?.truck) getTruckAsync(id);
  }, [id, state]); // eslint-disable-line react-hooks/exhaustive-deps

  const getTruckAsync = async (id) => {
    setLoading(true);
    const response = await Services.api.trucks.get(id);
    setLoading(false);

    if (!response.ok)
      return Services.utility.toast(
        "Could not fetch the truck",
        ThemeColorsEnum.error
      );

    setTruck(response.data);
  };

  return (
    <TruckFormPage
      breadcrumbs={breadcrumbs}
      title="Trucks - Edit"
      truck={truck}
    ></TruckFormPage>
  );
};

export default TruckEditPage;
